/**
 * @name intersperse
 *
 * Inserts an element between array items using a separator function. The
 * separator function is passed the previous index, the previous element, and
 * the next element.
 *
 * ```typescript
 * const nodeList: React.ReactNode[] = [...]
 * const commaSeparatedList = intersperse(nodeList, () => ', ')
 * const advancedSeparatedList = intersperse(nodeList, i => <Separator key={i}/>)
 * ```
 */
export function intersperse<T>(arr: T[], separator: (n: number, prev: T, curr: T) => T): T[] {
  return arr.flatMap((a, i) => (i > 0 ? [separator(i - 1, arr[i - 1], a), a] : [a]));
}
